import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
	routes: [
		{
			path: "/",
			name: "home",
			component: Home,
			meta: {
				breadcrumbs: [
					{ name: "Home" }
				]
			}
		},
		{
			path: "/artist/:artist/:section?",
			name: "artist",
			component: () => import("./views/Artist.vue"),
			meta: {
				breadcrumbs: [
					{ name: "Home", link: "/" },
					{ name: "Artist" }
				]
			}
		},
		{
			path: "/song/:song/:section?",
			name: "song",
			component: () => import("./views/Song.vue"),
			meta: {
				breadcrumbs: [
					{ name: "Home", link: "/" },
					{ name: "Song" }
				]
			}
		}
	],
	scrollBehavior () {
		return { x: 0, y: 0 };
	}
});
